import { MaskStylesObj } from '@reactour/mask';
import { PopoverStylesObj } from '@reactour/popover';
import { StylesObj } from '@reactour/tour';
import { AdvancedTourDefinition, ComponentTourId } from './shared-types';
import { getTourCompletedStep } from './component-tours';
import {
	getRestApiSenderAuthorizationSteps,
	getRestApiSenderBodySteps,
	getRestApiSenderHeaderSteps,
	getRestApiSenderQueryParameterSteps,
} from './component-tours/rest-api-sender';
import { MicroTaskConfigType } from 'ihub/common';

export default function getComponentTourRegistry({
	defaultStyles,
}: {
	defaultStyles: (StylesObj & PopoverStylesObj & MaskStylesObj) | undefined;
}): Record<ComponentTourId, AdvancedTourDefinition> {
	const componentTourCompleted = getTourCompletedStep({
		defaultStyles,
		selector: 'start-component-tour',
		completionId: 'task-definition-completed',
	});

	const componentTourRegistry: Record<ComponentTourId, AdvancedTourDefinition> = {
		RestApiSenderHeaders: {
			start: 'headers-add-key-value',
			steps: (runtime?: { config?: MicroTaskConfigType | undefined }) => [
				...getRestApiSenderHeaderSteps({ defaultStyles, microTaskConfigType: runtime?.config }),
				componentTourCompleted,
			],
			autoStartNext: false,
		},
		RestApiSenderQuery: {
			start: 'query-add-key-value',
			steps: (runtime?: { config?: MicroTaskConfigType | undefined }) => [
				...getRestApiSenderQueryParameterSteps({
					defaultStyles,
					microTaskConfigType: runtime?.config,
				}),
				componentTourCompleted,
			],
			autoStartNext: false,
		},
		RestApiSenderAuth: {
			start: 'auth-type-select',
			steps: (runtime?: { config?: MicroTaskConfigType | undefined }) => [
				...getRestApiSenderAuthorizationSteps({
					defaultStyles,
					microTaskConfigType: runtime?.config,
				}),
				componentTourCompleted,
			],
			autoStartNext: false,
		},
		RestApiBody: {
			start: 'payload-type',
			steps: (runtime?: { config?: MicroTaskConfigType | undefined }) => [
				...getRestApiSenderBodySteps({
					defaultStyles,
					microTaskConfigType: runtime?.config,
				}),
				componentTourCompleted,
			],
			autoStartNext: false,
		},
	};

	return componentTourRegistry;
}
